import moment from 'moment';

export default {
  booking (item) {
    console.log('item', item);
    if(!item) return null;

    if(!item.json) {
      item.json = JSON.parse(item.distance);
      item.ap_date = moment(item.ap_date).format('DD/MM/YYYY');
    }

    var date = moment(item.ap_date + ' ' + item.pick_time, "DD/MM/YYYY HH:mm:ss");

    var b = {
      id: item.id,
      type: item.type,
      price: item.price_driver,
      date: date.format('DD/MM/YYYY'),
      picktime: date.format('HH:mm'),
      trip: item.json[item.type][1].trip
    }
    return b
  }
}
